// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file event/v1/event.proto (package event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { Any } from "../../google/protobuf/any_pb";
import { BillingEventPayload } from "./billing_event_pb";
import { CheckoutTraceEventPayload } from "./checkout_trace_event_pb";
import { PaymentEventPayload } from "./payment_event_pb";
import { OrderEventPayload } from "./order_event_pb";

/**
 * This message type models events happening in the Checkout system. Example
 * events include:
 *   - user interactions initiated by shoppers in the browser UI.
 *   - public API calls invoked by merchants.
 *   - notifications created and sent to clients.
 *   - many more.
 *
 * Events are created in backend services and streamed to data storage for
 * analytical processing.
 *
 * Event id and server_time shall be generated in the Event library; while type,
 * metadata, and payload should be provided by the event initiator or client.
 *
 * @generated from message event.v1.Event
 */
export const Event = proto3.makeMessageType(
  "event.v1.Event",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "server_time", kind: "message", T: Timestamp },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(Event_Type) },
    { no: 4, name: "metadata", kind: "message", T: Event_Metadata },
    { no: 5, name: "payload", kind: "message", T: Any },
    { no: 6, name: "typed_payload", kind: "message", T: TypedPayload },
  ],
);

/**
 * Indicates the original source or producer of the an event.
 *
 * @generated from enum event.v1.Event.Client
 */
export const Event_Client = proto3.makeEnum(
  "event.v1.Event.Client",
  [
    {no: 0, name: "CLIENT_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CLIENT_API_GATEWAY", localName: "API_GATEWAY"},
    {no: 2, name: "CLIENT_FRONTEND", localName: "FRONTEND"},
    {no: 3, name: "CLIENT_PAYMENT", localName: "PAYMENT"},
    {no: 4, name: "CLIENT_ORDER", localName: "ORDER"},
    {no: 1000, name: "CLIENT_RDS_EXPORTER", localName: "RDS_EXPORTER"},
  ],
);

/**
 * Event types differentiate kinds of event payloads consumed by different
 * downstream processors.
 * After adding a new event type, please also update:
 * com/jpmorgan/cib/ms/checkout/common/event/EventClient.java:TYPE_HANDLERS
 * and EVENT_PAYLOAD_TYPE_REGISTRY.
 *
 * @generated from enum event.v1.Event.Type
 */
export const Event_Type = proto3.makeEnum(
  "event.v1.Event.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_BILLING", localName: "BILLING"},
    {no: 2, name: "TYPE_CHECKOUT_TRACE", localName: "CHECKOUT_TRACE"},
    {no: 3, name: "TYPE_PAY_PAYMENT", localName: "PAY_PAYMENT"},
    {no: 4, name: "TYPE_ORDER", localName: "ORDER"},
    {no: 1000, name: "TYPE_RDS_EXPORTED", localName: "RDS_EXPORTED"},
  ],
);

/**
 * Event's metadata holds basic information which applies to all event types.
 *
 * @generated from message event.v1.Event.Metadata
 */
export const Event_Metadata = proto3.makeMessageType(
  "event.v1.Event.Metadata",
  () => [
    { no: 1, name: "client", kind: "enum", T: proto3.getEnumType(Event_Client) },
    { no: 2, name: "client_time", kind: "message", T: Timestamp },
    { no: 3, name: "experiment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "device_ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "payment_gateway_mid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "shopper_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "correlation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Event_Metadata"},
);

/**
 * @generated from message event.v1.TypedPayload
 */
export const TypedPayload = proto3.makeMessageType(
  "event.v1.TypedPayload",
  () => [
    { no: 1, name: "billing", kind: "message", T: BillingEventPayload, oneof: "data" },
    { no: 2, name: "checkout_trace", kind: "message", T: CheckoutTraceEventPayload, oneof: "data" },
    { no: 3, name: "payment", kind: "message", T: PaymentEventPayload, oneof: "data" },
    { no: 4, name: "order", kind: "message", T: OrderEventPayload, oneof: "data" },
  ],
);

/**
 * A list of events for writing and reading in batches.
 *
 * @generated from message event.v1.EventBatch
 */
export const EventBatch = proto3.makeMessageType(
  "event.v1.EventBatch",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
  ],
);

